import Cta from 'creative-ui/uikit/Cta';
import CtaContainer from 'creative-ui/uikit/CtaContainer';
import { useTranslation } from 'react-i18next';

import { Flex } from '@/components/Layout/Flex/Flex';
import { trackClick } from '@/lib/tagging';
import { useLoginIdManager } from '@/screens/login-id/hooks/useLoginIdManager';

interface FranceConnectLinkFormProps {
  onConnectWithEmail: () => void;
}

/**
 * Intermediate screen shown on `login-id` when the FranceConnect linking
 * signal cookie is detected. Lets the user choose how they want to
 * authenticate against their existing ENGIE account so the DB PostLogin
 * Action can link their FranceConnect identity to it.
 */
export function FranceConnectLinkForm({
  onConnectWithEmail,
}: Readonly<FranceConnectLinkFormProps>) {
  const { t } = useTranslation('loginId');
  const { handlePasskeyLogin, isPasskeyEnabled } = useLoginIdManager();

  const handlePasskeyClick = async () => {
    trackClick('login/franceconnect-link/passkey');
    await handlePasskeyLogin();
  };

  const handleEmailClick = () => {
    trackClick('login/franceconnect-link/email');
    onConnectWithEmail();
  };

  return (
    <Flex direction="column" gapY={16}>
      {isPasskeyEnabled && (
        <CtaContainer stack>
          <Cta type="primary" onClick={handlePasskeyClick}>
            {t('franceConnectLinkForm.passkeyButtonText')}
          </Cta>
        </CtaContainer>
      )}
      <CtaContainer stack>
        <Cta type="secondary" onClick={handleEmailClick}>
          {t('franceConnectLinkForm.emailButtonText')}
        </Cta>
      </CtaContainer>
    </Flex>
  );
}
